<template>
  <b-modal id="studentsRemoveModal" class="studentsRemoveModal" size="lg">
    <template #modal-title>
      <h5>
        <em class="fas fa-user-minus"></em> Удаление учеников
      </h5>
    </template>

    <template #default>
      <div class="table" style="width: 100%; height: 40vh;">
        <ag-grid-vue
          style="width: 100%; height: 100%;"
          class="ag-theme-material"
          id="modalgrid"
          :gridOptions="gridOptions"
          :rowData="chosenStudents"
          :columnDefs="columnDefs"
          @onGridReady="onGridReady"
          :pagination="true"
          :paginationPageSize="20"
          :currentPage="1"
        >
        </ag-grid-vue>
      </div>
    </template>

    <template #modal-footer>
      <b-button cols="auto" @click="removeStudents"  variant="primary">
        Удалить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'StudentsRemoveModal',
  data() {
    return {
      columnDefs: [
        {
          headerName: 'E-mail',
          field: 'email'
        },
        {
          headerName: 'Фамилия',
          field: 'surname'
        },
        {
          headerName: 'Имя',
          field: 'name'
        },
        {
          headerName: 'Отчество',
          field: 'midname'
        }
      ],
      gridOptions: {
        defaultColDef: {
          autoHeight: false,
          sortable: true,
          suppressSizeToFit: true,
          headerClass: 'students-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      }
    }
  },
  props: {
    chosenStudents: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    removeStudentsId: {
      get() {
        return this.chosenStudents
      },
      set() {
        this.chosenStudents = this.$props.chosenStudents
        this.gridOptions.api.setRowData(this.chosenStudents)
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.setDomLayout('autoHeight')
    },
    closeModal() {
      this.$bvModal.hide('studentsRemoveModal')
    },
    removeStudents() {
      this.$emit('studentsRemoved')
      this.closeModal()
    }
  },
  components: {
    'ag-grid-vue': AgGridVue
  }
}
</script>

<style lang="scss">
@import "../../../sass/vendor/bootstrap/variables";

#studentsRemoveModal .table {
  justify-content: left;
}

.students-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #000;
  font-weight: bold;
}

.ag-theme-alpine {
  width: 100% !important;
  height: 20% !important;
}

.modal-footer {
  border: 0;
}

.studentsRemoveModal .ag-row .ag-cell {
  justify-content: left;
  text-align: left;
}
.studentsRemoveModal .ag-header-cell-label {
  justify-content: left;
}
</style>
